import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import StatusBullet from '../StatusBullet';

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
`
const IconButtonStyled = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`

class StatusBar extends Component {
  constructor(props) {
    super(props)
    this.state = {};
  }

  getStatusTexts = () => {
    const { statuses } = this.props;
    return Object.keys(statuses).map(key => {
      const item = statuses[key];
      return !item.value ? <StatusBullet value={item.value} text={item.text}/> : null;
    })
  }

  render() {
    const { onClose } = this.props;
    return (
      <Container>
        <IconButtonStyled onClick={onClose}>
          <Icon>close</Icon>
        </IconButtonStyled>
        <Content>
          {this.getStatusTexts()}
        </Content>
      </Container>
    );
  }
}

StatusBar.propTypes = {
  onClose: PropTypes.func,
  statuses: PropTypes.object,
}

StatusBar.defaultProps = {

}

export default StatusBar;
